// This is generated.  Alter it in blockGroups/formElements/types/Email.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const {
      id,
      title,
      propertyName,
      minLength,
      maxLength,
      required,
      defaultValue,
    } = hNode;
    //This block tells us nothing about namespaces/relations
    const subDataDictionary = {};

    // reuse consistent flags
    const { isRequired, isEditable, isOptional, forAction } =
      moduleRegistration.resolveFieldFlags(required, context);
    const maybeOptional = (schema) =>
      isOptional ? Type.Optional(schema) : schema;

    // The pattern previously used for email validation is not a valid JSON Schema regex value and will not validate as intended
    // In JSON Schema Draft 2020-12, the recommended way to validate an email address is by using the "format" keyword with the value "email"
    // While it is possible to use a custom pattern (regular expression) for email validation, using the format: "email" keyword is generally preferred
    // because it leverages the standardized validation rules provided by the JSON Schema specification
    // https://json-schema.org/draft/2020-12/json-schema-validation#name-email-addresses
    // const pattern = "/^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61} [a-zA-Z0-9])? (?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/";

    // Build the string schema with email format and constraints
    const stringOptions = {
      title: title,
      format: 'email',
      'x-id': id,
      'x-dataType': 'string',
      'x-propertyName': propertyName,
      'x-required': isRequired,
      'x-optional': isOptional,
      'x-editable': isEditable,
    };

    // Add forAction annotation if this field is within a DetailPane with a specific action
    if (forAction) {
      stringOptions['x-forAction'] = forAction;
    }

    // Add length constraints if provided
    if (minLength !== undefined && minLength !== null) {
      stringOptions.minLength = minLength;
    }
    if (maxLength !== undefined && maxLength !== null) {
      stringOptions.maxLength = maxLength;
    }
    if (defaultValue !== undefined && defaultValue !== null) {
      stringOptions.default = defaultValue;
    }

    const emailSchema = maybeOptional(Type.String(stringOptions));

    // The partial type definition is a plain object with the property schema
    const partialTypeDefinition = {
      [propertyName]: emailSchema,
    };

    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType('formElements', 'Email', module.exports);
